<template lang="pug">
  .v-card(:class="classes")
    slot
</template>

<script>
export default {
  name: 'VCard',

  props: {
    danger: Boolean,
    elevated: Boolean,
    overflowHidden: Boolean,
    disabled: Boolean,
    deleted: Boolean
  },

  computed: {
    classes () {
      return {
        'v-card--danger': this.danger,
        'v-card--deleted': this.deleted,
        'v-card--disabled': this.disabled,
        'v-card--elevated': this.elevated,
        'v-card--overflow-hiden': this.overflowHidden
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';
  @import '_variables.scss';

  .v-card {
    width: 100%;
    border-radius: $v-card-border-radius;
    background-color: $color-white;

    &--disabled {
      background-color: $color-gray-light-2;
    }

    &--elevated {
      box-shadow: $v-card-shadow-1;
    }

    &--overflow-hiden {
      overflow: hidden;
    }

    &--danger {
      border: .1rem solid $color-red;
      background-color: $color-red-lighten-4;
    }

    &--deleted {
      background-color: $color-red-light-3;
    }

    &__title {
      padding: 2.4rem 2.4rem 0;
      font-size: 1.8rem;
    }

    &__content {
      padding: 2rem 2.4rem 2.4rem;
      font-size: 1.4rem;
      font-weight: 400;

      &--full {
        padding: 2.4rem 0;
      }
    }

    &__actions {
      padding: 0 2.4rem 2.4rem;

      &--center {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>
